import {
  LockKeyhole,
  LogsIcon,
  TypeOutlineIcon,
  UsersRoundIcon,
  WorkflowIcon,
  WrenchIcon,
} from "lucide-react";
import { useNavigate } from "react-router-dom";

import { LenderUserRoleEnum } from "@/features/common/enums";
import { useGetCurrentLenderCompanyQuery } from "@/features/lender-companies/hooks/use-get-lender-company.query";

import { NavGroup } from "./nav-group";

export const NavAdmin = () => {
  const navigate = useNavigate();
  const { data: lenderCompany } = useGetCurrentLenderCompanyQuery();

  if (lenderCompany?.userSettings?.role === LenderUserRoleEnum.CREDIT_OFFICER) {
    return null;
  }
  const adminItems = {
    title: "Admin",
    icon: LockKeyhole,
    isActive: false,
    items: [
      {
        title: "Lender profile",
        onClick: () =>
          navigate(`/lender-company/${lenderCompany?.id}/company-profile`),
        isActive: false,
        icon: TypeOutlineIcon,
      },
      {
        title: "Team",
        onClick: () => navigate(`/lender-company/${lenderCompany?.id}/team`),
        isActive: false,
        icon: UsersRoundIcon,
      },
    ],
  };

  const developerItems = {
    title: "Developer",
    isActive: false,
    icon: WorkflowIcon,
    items: [
      {
        title: "API Configuration",
        onClick: () => navigate(`/lender-company/${lenderCompany?.id}/api`),
        isActive: false,
        icon: WrenchIcon,
      },
      {
        title: "Integration log",
        onClick: () =>
          navigate(`/lender-company/${lenderCompany?.id}/api-logs`),
        isActive: false,
        icon: LogsIcon,
      },
    ],
  };

  if (lenderCompany?.userSettings?.role === LenderUserRoleEnum.DEVELOPER) {
    return <NavGroup items={[developerItems]} />;
  }

  return <NavGroup items={[adminItems, developerItems]} />;
};
